import React, { forwardRef, isValidElement } from "react";
import { Tooltip } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const needsSpanWrap = (child) => {
  if (!isValidElement(child)) return true;
  if (child.type === React.Fragment) return true;
  if (child.props?.disabled) return true;
  return false;
};

const AppTooltip = forwardRef(function AppTooltip(
  {
    titleKey,
    title,
    children,
    placement = "top",
    arrow = true,
    enterDelay = 400,
    leaveDelay = 100,
    disableHoverListener,
    ...rest
  },
  ref
) {
  let resolvedTitle = title;
  if (titleKey) {
    if (process.env.NODE_ENV !== "production" && title) {
      // eslint-disable-next-line no-console
      console.warn(
        "[AppTooltip] Both 'titleKey' and 'title' provided; 'titleKey' wins."
      );
    }
    resolvedTitle = i18n.t(titleKey);
  }

  if (resolvedTitle === undefined || resolvedTitle === null || resolvedTitle === "") {
    return children;
  }

  const safeChild = needsSpanWrap(children) ? (
    <span style={{ display: "inline-flex" }}>{children}</span>
  ) : (
    children
  );

  return (
    <Tooltip
      ref={ref}
      title={resolvedTitle}
      arrow={arrow}
      placement={placement}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      disableHoverListener={disableHoverListener}
      {...rest}
    >
      {safeChild}
    </Tooltip>
  );
});

export default AppTooltip;
